import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faHome,faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons'

library.add(fab,faHome, faCheckSquare, faCoffee)